export const COCKPIT_URL = window.location.origin + '/cockpit/angular';

export const LOCAL_URL = 'http://127.0.0.1:9000';
